export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11897.f31d9219.jpg";